import { useAws } from "src/networking/aws/aws.hook";
import {
  AwsGateCallbacks,
  AwsGateRequest,
  DeleteVehicleDocumentsDraft,
  GetVehicleDocumentsDraft,
  GetVehicleDraft,
  GetVehicleInfo,
  GetVehicleLicenseTypes,
  PostVehicleDocumentsDraft,
  PutVehicleDraft,
  ServiceType,
} from "src/types";

export const useGetVehicleDraft = <
  T extends GetVehicleDraft["request"],
  D extends GetVehicleDraft["response"],
>() => {
  const hook = useAws<T, D>("getVehicleDraft", ServiceType.CAI);

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      const draftId = request.uriParams.idBozza;

      return hook.crossGate(
        {
          method: "get",
          path: `/bozza/${draftId}/veicolo`,
          ...request,
        },
        callbacks
      );
    },
  };
};

export const usePutVehicleDraft = <
  T extends PutVehicleDraft["request"],
  D extends GetVehicleDraft["response"],
>() => {
  const hook = useAws<T, D>("putVehicleDraft", ServiceType.CAI);

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      const draftId = request.uriParams.idBozza;

      return hook.crossGate(
        {
          method: "put",
          path: `/bozza/${draftId}/veicolo`,
          ...request,
        },
        callbacks
      );
    },
  };
};

export const useGetVehicleInfo = <
  T extends GetVehicleInfo["request"],
  D extends GetVehicleInfo["response"],
>() => {
  const hook = useAws<T, D>("getVehicleInfo", ServiceType.CAI);

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      const plate = request.queryParams.targa;
      const birthDate = request.queryParams.dataNascita;

      var queryParams = `targa=${plate}`;
      if (birthDate) queryParams = `${queryParams}&dataNascita=${birthDate}`;

      return hook.crossGate(
        {
          method: "get",
          path: `/veicolo?${queryParams}`,
          ...request,
        },
        callbacks
      );
    },
  };
};

export const useGetVehicleDocumentsDraft = <
  T extends GetVehicleDocumentsDraft["request"],
  D extends GetVehicleDocumentsDraft["response"],
>() => {
  const hook = useAws<T, D>("getVehicleDocumentsDraft", ServiceType.DOCUMENT);

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      const draftId = request.uriParams.idBozza;

      return hook.crossGate(
        {
          method: "get",
          path: `/documenti/${draftId}`,
          ...request,
        },
        callbacks
      );
    },
  };
};

export const usePostVehicleDocumentsDraft = <
  T extends PostVehicleDocumentsDraft["request"],
  D extends PostVehicleDocumentsDraft["response"],
>() => {
  const hook = useAws<T, D>("postVehicleDocumentsDraft", ServiceType.DOCUMENT);

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      const draftId = request.queryParams.idBozza;
      const vehicleType = request.queryParams.tipoVeicolo;
      const name = request.queryParams.nome;

      var queryParams = `idBozza=${draftId}&tipoDocumento=ALLEGATI&tipoVeicolo=${vehicleType}`;
      if (name) queryParams = `${queryParams}&nome=${name}`;

      return hook.crossGate(
        {
          method: "post",
          path: `/documento?${queryParams}`,
          ...request,
        },
        callbacks
      );
    },
  };
};

export const useDeleteVehicleDocumentsDraft = <
  T extends DeleteVehicleDocumentsDraft["request"],
  D extends DeleteVehicleDocumentsDraft["response"],
>() => {
  const hook = useAws<T, D>(
    "deleteVehicleDocumentsDraft",
    ServiceType.DOCUMENT
  );

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      const documentId = request.uriParams.idDocumento;

      return hook.crossGate(
        {
          method: "del",
          path: `/documento/${documentId}`,
          ...request,
        },
        callbacks
      );
    },
  };
};

export const useGetVehicleLicenseTypes = <
  T extends GetVehicleLicenseTypes["request"],
  D extends GetVehicleLicenseTypes["response"],
>() => {
  const hook = useAws<T, D>("getVehicleLicenseTypes", ServiceType.CAI);

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      return hook.crossGate(
        {
          method: "get",
          path: "/bozza/patente/categorie",
          ...request,
        },
        callbacks
      );
    },
  };
};
